// extracted by mini-css-extract-plugin
module.exports = {"placedholderText":"placeholderText_placedholderText__FpOVC","textBar":"placeholderText_textBar__8Smz9","color":"placeholderText_color__gwEda"};